import {ModuleWithProviders, NgModule} from '@angular/core';
import {OptimizerService} from '../../interfaces/engin/optimizer';
import {OptimizerServiceImpl} from './services/optimizer.service';
import {AssetsApi} from './api/assets.api';
import {AnalyzerApi} from './api/analyzer.api';
import {OptimizerApi} from './api/optimizer.api';
import {AssetsServiceImpl} from './services/assets.service';
import {AssetsService} from '../../interfaces/engin/assets';
import {AnalyzerService} from '../../interfaces/engin/analyzer';
import {AnalyzerServiceImpl} from './services/analyzer.service';
import {CommonModule} from '@angular/common';
import {CommonBackendModule} from '../common/common-backend.module';
import {ForecasterApi} from './api/forecaster.api';
import {ForecasterService} from '../../interfaces/engin/forecaster';
import {ForecasterServiceImpl} from './services/forecaster.service';
import {PlannerApi} from './api/planner.api';
import {AssetDataAuditApi} from './api/data-audit/asset-data-audit.api';
import {AssetDataAuditService} from '../../interfaces/engin/data-audit/asset-data-audit';
import {AssetDataAuditServiceImpl} from './services/data-audit/asset-data-audit.service';
import {WorkflowApi} from './api/workflow.api';
import {WorkflowService} from '@core/interfaces/engin/workflow';
import {WorkflowServiceImpl} from './services/workflow.service';
import {WorkflowValidationService} from '../../interfaces/engin/workflow-validation';
import {WorkflowValidationServiceImpl} from './services/workflow-validation.service';
import {WorkflowValidationApi} from './api/workflow-validation.api';
import {EvaluationDataAuditApi} from './api/data-audit/evaluation-data-audit.api';
import {EvaluationDataAuditServiceImpl} from './services/data-audit/evaluation-data-audit.service';
import {EvaluationDataAuditService} from '../../interfaces/engin/data-audit/evaluation-data-audit';
import {ReportingApi} from '@core/backend/engin/api/reporting.api';
import {ReportingService} from '@core/interfaces/engin/reporting';
import {ReportingServiceImpl} from '@core/backend/engin/services/reporting.service';
import {ConnectivityApi} from '@core/backend/engin/api/connectivity.api';
import {ConnectivityService} from '@core/interfaces/engin/connectivity';
import {ConnectivityServiceImpl} from '@core/backend/engin/services/connectivity.service';
import {JobsApi} from './api/jobs.api';
import {JobsService} from '../../interfaces/engin/jobs';
import {JobsServiceImpl} from './services/jobs.service';
import {LiveApi} from '@core/backend/engin/api/live/live.api';
import {LiveService} from '@core/interfaces/live/live';
import {LiveServiceImpl} from '@core/backend/engin/services/live/live.service';
import {AssetDetailsApi} from '@core/backend/engin/api/asset-details.api';
import {AssetDetailsService} from '@core/interfaces/engin/asset-details';
import {AssetDetailsServiceImpl} from '@core/backend/engin/services/asset-details.service';
import {Sf6GasLeakService} from '@core/interfaces/live/sf6-gas-leak';
import {Sf6GasLeakServiceImpl} from '@core/backend/engin/services/live/sf6-gas-leak.service';
import {HydrogenTrendingService} from '@core/interfaces/live/hydrogen-tending';
import {HydrogenTrendingServiceImpl} from '@core/backend/engin/services/live/hydrogen-trending.service';
import {OilTemperatureMoistureService} from '@core/interfaces/live/oil-temperature-moisture';
import {OilTemperatureMoistureServiceImpl} from '@core/backend/engin/services/live/oil-temperature-moisture.service';
import {Co2LoadService} from '@core/interfaces/live/co2-load';
import {Co2LoadServiceImpl} from '@core/backend/engin/services/live/co2-load.service';
import {OnlineDgaService} from '@core/interfaces/live/online-dga';
import {OnlineDgaServiceImpl} from '@core/backend/engin/services/live/online-dga.service';
import {InsulationMoistureService} from '@core/interfaces/live/insulation-moisture';
import {InsulationMoistureServiceImpl} from '@core/backend/engin/services/live/insulation-moisture.service';
import {Sf6GasLeakApi} from '@core/backend/engin/api/live/sf6-gas-leak.api';
import {HydrogenTrendingApi} from '@core/backend/engin/api/live/hydrogen-trending.api';
import {OilTemperatureMoistureApi} from '@core/backend/engin/api/live/oil-temperature-moisture.api';
import {Co2LoadApi} from '@core/backend/engin/api/live/co2-load.api';
import {OnlineDgaApi} from '@core/backend/engin/api/live/online-dga.api';
import {InsulationMoistureApi} from '@core/backend/engin/api/live/insulation-moisture.api';
import {LoadForecastApi} from '@core/backend/engin/api/load-forecast/load-forecast.api';
import {LoadForecastService} from '@core/interfaces/engin/load-forecast/load-forecast';
import {LoadForecastServiceImpl} from '@core/backend/engin/services/load-forecast/load-forecast.service';
import {DataPreparationService} from '@core/interfaces/engin/data-preparation';
import {DataPreparationServiceImpl} from '@core/backend/engin/services/data-preparation.service';
import {DataPreparationApi} from '@core/backend/engin/api/data-preparation.api';
import {ScenarioLoadForecastService} from '@core/interfaces/engin/load-forecast/scenario';
import {ScenarioLoadForecastApi} from '@core/backend/engin/api/load-forecast/scenario.api';
import {ScenarioLoadForecastServiceImpl} from './services/load-forecast/scenario.service';
import {StationLoadForecastServiceImpl} from '@core/backend/engin/services/load-forecast/station.service';
import {SystemLoadForecastService} from '@core/interfaces/engin/load-forecast/system';
import {SystemLoadForecastServiceImpl} from '@core/backend/engin/services/load-forecast/system.service';
import {StationLoadForecastService} from '@core/interfaces/engin/load-forecast/station';
import {FeederLoadForecastService} from '@core/interfaces/engin/load-forecast/feeder';
import {FeederLoadForecastServiceImpl} from '@core/backend/engin/services/load-forecast/feeder.service';
import {VaultLoadForecastService} from '@core/interfaces/engin/load-forecast/vault';
import {DemandFactorService} from '@core/interfaces/engin/load-forecast/demand-factor';
import {VaultLoadForecastServiceImpl} from '@core/backend/engin/services/load-forecast/vault.service';
import {DemandFactorServiceImpl} from '@core/backend/engin/services/load-forecast/demand-factor.service';
import {SystemLoadForecastApi} from '@core/backend/engin/api/load-forecast/system.api';
import {StationLoadForecastApi} from '@core/backend/engin/api/load-forecast/station.api';
import {FeederLoadForecastApi} from '@core/backend/engin/api/load-forecast/feeder.api';
import {VaultLoadForecastApi} from '@core/backend/engin/api/load-forecast/vault.api';
import {DemandFactorApi} from '@core/backend/engin/api/load-forecast/demand-factor.api';
import {SectionLoadForecastServiceImpl} from './services/load-forecast/line-section.service';
import {SectionLoadForecastService} from '@core/interfaces/engin/load-forecast/line-section';
import {SectionLoadForecastApi} from '@core/backend/engin/api/load-forecast/line-section.api';
import {MeterLoadForecastApi} from './api/load-forecast/meter.api';
import {DxTransformerLoadForecastService} from '@core/interfaces/engin/load-forecast/dx-transformer';
import {DxTransformerLoadForecastServiceImpl} from './services/load-forecast/dx-transformer.service';
import {MeterLoadForecastService} from '@core/interfaces/engin/load-forecast/meter';
import {MeterLoadForecastServiceImpl} from './services/load-forecast/meter.service';
import {DxTransformerLoadForecastApi} from '@core/backend/engin/api/load-forecast/dx-transformer.api';
import {LandingZoneService} from '@core/interfaces/landing-zone';
import {LandingZoneServiceImpl} from '@core/backend/engin/services/landing-zone.service';
import {LandingZoneApi} from '@core/backend/engin/api/landing-zone.api';
import {ReportConfigApi} from './api/reporting/report-config.api';
import {ReportDataApi} from '@core/backend/engin/api/reporting/report-data.api';
import {ReportRenderApi} from '@core/backend/engin/api/reporting/report-render.api';
import {ReportConfigService} from '@core/interfaces/engin/reporting/report-config';
import {ReportRenderService} from '@core/interfaces/engin/reporting/report-render';
import {ReportDataService} from '@core/interfaces/engin/reporting/report-data';
import {ReportConfigServiceImpl} from '@core/backend/engin/services/reporting/report-config.service';
import {ReportDataServiceImpl} from '@core/backend/engin/services/reporting/report-data.service';
import {ReportRenderServiceImpl} from '@core/backend/engin/services/reporting/report-render.service';
import {ProgramService} from '@core/interfaces/engin/program-management/program';
import {ProgramServiceImpl} from './services/program-management/program.service';
import {SegmentApi} from './api/program-management/segment.api';
import {SegmentService} from '@core/interfaces/engin/program-management/segment';
import {SegmentServiceImpl} from './services/program-management/segment.service';
import {ProjectService} from '@core/interfaces/engin/program-management/project';
import {ProjectServiceImpl} from './services/program-management/project.service';
import {ProgramApi} from './api/program-management/program.api';
import {ProjectApi} from './api/program-management/project.api';
import {PmSensitivityService} from '@core/interfaces/engin/program-management/pm-sensitivity';
import {PmSensitivityServiceImpl} from './services/program-management/pm-sensitivty.service';
import {PmSensitivityApi} from './api/program-management/pm-sensitivity.api';
import {AssetRegistryServiceImpl} from '@core/backend/engin/services/asset-registry.service';
import {AssetRegistryService} from '@core/interfaces/asset-registry';
import {AssetRegistryApi} from '@core/backend/engin/api/asset-registry.api';
import {StatusChangeService} from '@core/interfaces/engin/status-change';
import {StatusChangeServiceImpl} from './services/status-change.service';
import {StatusChangeApi} from './api/status-change.api';
import {MaintenancePlanningService} from '@core/interfaces/engin/maintenance-planning/maintenance-planning';
import {MaintenancePlanningServiceImpl} from '@core/backend/engin/services/maintenance-planning/maintenance-planning.service';
import {MaintenancePlanningApi} from '@core/backend/engin/api/maintenace-planning/maintenance-planning.api';
import {RulesService} from '@core/interfaces/engin/inspection-rules/rules';
import {RulesServiceImpl} from '@core/backend/engin/services/inspection-rules/rules.service';
import {RulesApi} from '@core/backend/engin/api/inspection-rules/rules.api';
import {S3Api} from '@core/backend/common/api/s3.api';
import {S3ServiceImpl} from '@core/backend/engin/services/s3Service';
import {S3Service} from '@core/interfaces/common/s3';
import {ThicknessRateService} from '@core/interfaces/live/thickness-rate';
import {ThicknessRateServiceImpl} from '@core/backend/engin/services/live/thickness-rate.service';
import {ThicknessRateApi} from '@core/backend/engin/api/live/thickness-rate.api';
import {FeederReviewLPApi} from '@core/backend/engin/api/load-profile-analysis/feeder-review.api';
import {FeederReviewLPServiceImpl} from '@core/backend/engin/services/load-profile-analysis/feeder-review.service';
import {FeederReviewLPService} from '@core/interfaces/engin/load-profile-analysis/feeder-review';
import {OutputMeterLPApi} from '@core/backend/engin/api/load-profile-analysis/output-meter.api';
import {OutputMeterLPServiceImpl} from '@core/backend/engin/services/load-profile-analysis/output-meter.service';
import {OutputMeterLPService} from '@core/interfaces/engin/load-profile-analysis/output-meter';
import {FeederAnalysisLPApi} from '@core/backend/engin/api/load-profile-analysis/feeder-analysis.api';
import {FeederAnalysisLPService} from '@core/interfaces/engin/load-profile-analysis/feeder-analysis';
import {FeederAnalysisLPServiceImpl} from '@core/backend/engin/services/load-profile-analysis/feeder-analysis.service';
import {LpFeederOutlierApi} from '@core/backend/engin/api/load-profile-analysis/feeder-outlier.api';
import {LpFeederOutlierService} from '@core/interfaces/engin/load-profile-analysis/feeder-outlier';
import {LpFeederOutlierServiceImpl} from '@core/backend/engin/services/load-profile-analysis/feeder-outlier.service';
import {PowerMeterReadingApi} from '@core/backend/engin/api/load-profile-analysis/power-meter-reading.api';
import {PowerMeterReadingService} from '@core/interfaces/engin/load-profile-analysis/power-meter-reading';
import {PowerMeterReadingServiceImpl} from '@core/backend/engin/services/load-profile-analysis/power-meter-reading.service';
import {PmReportingServiceImpl} from '@core/backend/engin/services/program-management/pm-reporting.service';
import {PmReportingService} from '@core/interfaces/engin/program-management/pm-reporting';
import {PmReportingApi} from '@core/backend/engin/api/program-management/pm-reporting.api';
import {AlternativeService} from '@core/interfaces/engin/program-management/alternative';
import {AlternativeServiceImpl} from '@core/backend/engin/services/program-management/alternative.service';
import {AlternativeApi} from '@core/backend/engin/api/program-management/alternative.api';
import {N1AnalysisApi} from '@core/backend/engin/api/load-forecast/n1-analysis.api';
import {N1AnalysisServiceImpl} from '@core/backend/engin/services/load-forecast/n1-analysis.service';
import {N1AnalysisService} from '@core/interfaces/engin/load-forecast/n1-analysis';
import {BatteryBankApi} from '@core/backend/engin/api/live/battery-bank.api';
import {BatteryBankServiceImpl} from '@core/backend/engin/services/live/battery-bank.service';
import {BatteryBankService} from '@core/interfaces/live/battery-bank';
import {VegClearanceApi} from '@core/backend/engin/api/live/veg-clearance.api';
import {VegClearanceService} from '@core/interfaces/live/veg-clearance';
import {VegClearanceServiceImpl} from '@core/backend/engin/services/live/veg-clearance.service';
import {GroupInspectionsServiceImpl} from '@core/backend/engin/services/mobile-admin/group-inspections.service';
import {GroupInspectionsService} from '@core/interfaces/engin/mobile-admin/group-inspections';
import {GroupInspectionsApi} from '@core/backend/engin/api/mobile-admin/group-inspections.api';
import {GroupInspectionValuesService} from '@core/interfaces/engin/mobile-admin/group-inspection-values';
import {GroupInspectionValuesServiceImpl} from '@core/backend/engin/services/mobile-admin/group-inspection-values.service';
import {GroupInspectionValuesApi} from '@core/backend/engin/api/mobile-admin/group-inspection-values.api';
import {GroupsServiceImpl} from '@core/backend/engin/services/demo/groups.service';
import {GroupsService} from '@core/interfaces/engin/demo/groups';
import {GroupsApi} from '@core/backend/engin/api/demo/groups.api';

const API = [
    AnalyzerApi,
    AssetsApi,
    OptimizerApi,
    ForecasterApi,
    WorkflowApi,
    WorkflowValidationApi,
    AssetDataAuditApi,
    EvaluationDataAuditApi,
    ConnectivityApi,
    ReportingApi,
    PlannerApi,
    PmSensitivityApi,
    PmReportingApi,
    SegmentApi,
    ProgramApi,
    ProjectApi,
    AlternativeApi,
    LandingZoneApi,
    LiveApi,
    JobsApi,
    AssetDetailsApi,
    AssetRegistryApi,
    StatusChangeApi,
    MaintenancePlanningApi,
    RulesApi,
    FeederReviewLPApi,
    OutputMeterLPApi,
    FeederAnalysisLPApi,
    LpFeederOutlierApi,
    PowerMeterReadingApi,
    GroupInspectionsApi,
    GroupInspectionValuesApi,

    ReportConfigApi,
    ReportDataApi,
    ReportRenderApi,
    S3Api,

    // Demo only
    GroupsApi,
];

const LIVE_API = [
    LiveApi,
    Sf6GasLeakApi,
    HydrogenTrendingApi,
    OilTemperatureMoistureApi,
    Co2LoadApi,
    OnlineDgaApi,
    InsulationMoistureApi,
    ThicknessRateApi,
    BatteryBankApi,
    VegClearanceApi,
];

const FORECAST_API = [
    LoadForecastApi,
    ScenarioLoadForecastApi,
    SystemLoadForecastApi,
    StationLoadForecastApi,
    FeederLoadForecastApi,
    VaultLoadForecastApi,
    SectionLoadForecastApi,
    DxTransformerLoadForecastApi,
    MeterLoadForecastApi,
    DemandFactorApi,
    DataPreparationApi,
    N1AnalysisApi,
];

const SERVICES = [
    {provide: AnalyzerService, useClass: AnalyzerServiceImpl},
    {provide: AssetsService, useClass: AssetsServiceImpl},
    {provide: OptimizerService, useClass: OptimizerServiceImpl},
    {provide: ForecasterService, useClass: ForecasterServiceImpl},
    {provide: WorkflowService, useClass: WorkflowServiceImpl},
    {provide: WorkflowValidationService, useClass: WorkflowValidationServiceImpl},
    {provide: AssetDataAuditService, useClass: AssetDataAuditServiceImpl},
    {provide: EvaluationDataAuditService, useClass: EvaluationDataAuditServiceImpl},
    {provide: ConnectivityService, useClass: ConnectivityServiceImpl},
    {provide: ReportingService, useClass: ReportingServiceImpl},
    {provide: PmSensitivityService, useClass: PmSensitivityServiceImpl},
    {provide: PmReportingService, useClass: PmReportingServiceImpl},
    {provide: SegmentService, useClass: SegmentServiceImpl},
    {provide: ProgramService, useClass: ProgramServiceImpl},
    {provide: ProjectService, useClass: ProjectServiceImpl},
    {provide: AlternativeService, useClass: AlternativeServiceImpl},
    {provide: LandingZoneService, useClass: LandingZoneServiceImpl},
    {provide: AssetRegistryService, useClass: AssetRegistryServiceImpl},
    {provide: JobsService, useClass: JobsServiceImpl},
    {provide: LiveService, useClass: LiveServiceImpl},
    {provide: AssetDetailsService, useClass: AssetDetailsServiceImpl},
    {provide: ReportConfigService, useClass: ReportConfigServiceImpl},
    {provide: ReportDataService, useClass: ReportDataServiceImpl},
    {provide: ReportRenderService, useClass: ReportRenderServiceImpl},
    {provide: StatusChangeService, useClass: StatusChangeServiceImpl},
    {provide: MaintenancePlanningService, useClass: MaintenancePlanningServiceImpl},
    {provide: RulesService, useClass: RulesServiceImpl},
    {provide: S3Service, useClass: S3ServiceImpl},
    {provide: FeederReviewLPService, useClass: FeederReviewLPServiceImpl},
    {provide: OutputMeterLPService, useClass: OutputMeterLPServiceImpl},
    {provide: FeederAnalysisLPService, useClass: FeederAnalysisLPServiceImpl},
    {provide: LpFeederOutlierService, useClass: LpFeederOutlierServiceImpl},
    {provide: PowerMeterReadingService, useClass: PowerMeterReadingServiceImpl},
    {provide: GroupInspectionsService, useClass: GroupInspectionsServiceImpl},
    {provide: GroupInspectionValuesService, useClass: GroupInspectionValuesServiceImpl},

    // Demo only
    {provide: GroupsService, useClass: GroupsServiceImpl},
];

const LIVE_SERVICES = [
    {provide: LiveService, useClass: LiveServiceImpl},
    {provide: Sf6GasLeakService, useClass: Sf6GasLeakServiceImpl},
    {provide: HydrogenTrendingService, useClass: HydrogenTrendingServiceImpl},
    {provide: OilTemperatureMoistureService, useClass: OilTemperatureMoistureServiceImpl},
    {provide: Co2LoadService, useClass: Co2LoadServiceImpl},
    {provide: OnlineDgaService, useClass: OnlineDgaServiceImpl},
    {provide: InsulationMoistureService, useClass: InsulationMoistureServiceImpl},
    {provide: ThicknessRateService, useClass: ThicknessRateServiceImpl},
    {provide: BatteryBankService, useClass: BatteryBankServiceImpl},
    {provide: VegClearanceService, useClass: VegClearanceServiceImpl},
];

const FORECAST_SERVICES = [
    {provide: LoadForecastService, useClass: LoadForecastServiceImpl},
    {provide: ScenarioLoadForecastService, useClass: ScenarioLoadForecastServiceImpl},
    {provide: SystemLoadForecastService, useClass: SystemLoadForecastServiceImpl},
    {provide: StationLoadForecastService, useClass: StationLoadForecastServiceImpl},
    {provide: FeederLoadForecastService, useClass: FeederLoadForecastServiceImpl},
    {provide: VaultLoadForecastService, useClass: VaultLoadForecastServiceImpl},
    {provide: SectionLoadForecastService, useClass: SectionLoadForecastServiceImpl},
    {provide: DxTransformerLoadForecastService, useClass: DxTransformerLoadForecastServiceImpl},
    {provide: MeterLoadForecastService, useClass: MeterLoadForecastServiceImpl},
    {provide: DemandFactorService, useClass: DemandFactorServiceImpl},
    {provide: DataPreparationService, useClass: DataPreparationServiceImpl},
    {provide: N1AnalysisService, useClass: N1AnalysisServiceImpl},
];

@NgModule({
    imports: [CommonModule, CommonBackendModule],
    exports: [CommonBackendModule],
})
export class EnginBackendModule {
    static forRoot(): ModuleWithProviders<EnginBackendModule> {
        return {
            ngModule: EnginBackendModule,
            providers: [...API, ...LIVE_API, ...FORECAST_API, ...SERVICES, ...LIVE_SERVICES, ...FORECAST_SERVICES],
        };
    }
}
